import { useContext } from 'react'

import { HeaderContext } from '@context/headerContext'

export function useHeader() {
  return useContext(HeaderContext)
}
